var forms = {
    selectors: {
        formSelector: '.previo-forms',
    },
    init: function () {
        var self = this;

        if( jQuery( self.selectors.formSelector ).length ) {
            jQuery( self.selectors.formSelector ).each( function() {
                jQuery( this ).submit(function( event ){
                    event.preventDefault( event );
                    var form = jQuery( this );

                    //form.find( '.previo-forms__response p' ).text( '' );
                    form.find( '.previo-forms__response' ).addClass( 'hidden' );

                    if( self.validateFormFields( form ) ) {
                        self.ajaxCall( form );
                    }
                });

                if( jQuery( this ).find('#recipient').length ) {
                    $('#recipient').val(self.getUrlVars()['recipient']);
                }
            });
        }
    },
    validateFormFields: function( form ) {
        var self = this;

        jQuery( form ).find( '.previo-forms__input' ).each( function() {
            if( ! self.checkField( jQuery( this ) ) ) {
                form.find( '.previo-forms__response' ).removeClass( 'hidden' ).addClass('alert-danger');
                form.find( '.previo-forms__response p' ).text( 'Něco je špatně.' );

                return false;
            }
        });

        return true;
    },
    ajaxCall: function( form ) {
        var formData = jQuery( form ).serialize(),
            redirectUrl = form.find( 'input#redirect-url' ).val();

        jQuery.ajax({
            cache: false,
            type: "post",
            dataType: "json",
            url: sikmoVars.ajax_url,
            data: formData,
            crossDomain: true,
            headers: {
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*",
                "Access-Control-Allow-Credentials": true
            },
            success: function(response) {
                if (redirectUrl.length) {
                    location.href = redirectUrl;
                    return;
                }

                // ✅ find hidden input with JSON payload
                var dataLayerInput = form.find('#datalayer_push');
                if (dataLayerInput.length && dataLayerInput.val().trim().length) {
                    try {
                        var payload = JSON.parse(dataLayerInput.val().trim());
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(payload);
                    } catch (e) {
                        console.warn('Neplatný JSON v #datalayer_push:', e);
                    }
                }

                form[0].reset();
                form.find('.previo-forms__response').removeClass('hidden').addClass('alert-success');
            },
            fail : function( response ){
                form.find( '.previo-forms__response' ).removeClass( 'hidden' ).addClass('alert-danger');
                form.find( '.previo-forms__response p' ).text( response.data.message );
            }
        });
    },
    checkField: function( element ) {
        var self = this;

        if( jQuery( element ).attr( 'required' ) == 'reqired' && jQuery( element ).val() == '' ) {
            return false;
        }

        return true;
    },
    getUrlVars: function (){
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
};

export { forms };
